import React from 'react';
import { Container, Image,Button } from 'react-bootstrap';
import Fade from 'react-reveal/Fade';
import me from '../../../images/me222.png'
const About = () => {
    return (
        <div id='about'>
           <h3 className="text-center mt-5" style={{fontSize:"30px",fontWeight:'bold', fontFamily:'cursive'}}>Little Stroy <span style={{fontSize:"30px",fontWeight:'bold',color:'#0FDCDC'}}>About Me</span></h3>

         <Container style={{marginTop:''}}>
         <div className="row">
               <div className="col-md-6">

                   <Image style={{width:'100%',height:'500px'}} src={me} alt="" />

               </div>
               <div style={{marginTop:'100px'}} className="col-md-5">
                <Fade right>
                <h4>A Story Of Hridoy Ahmed</h4>
                   <p className="mt-5 text-muted">I am an enthusiastic Frontend developer with knowing some framework for the frontend and the backend. I know Basic PHP and MySQL but basically a MERN developer.</p> <br/>

                   <p className="text-muted">
                   I have completed my BSc degree in Computer Science and Engineering from PrimeAsia University. My programming started with C language.  After that I shift to javascript because javascript is very important to learn how to react to javascript's most popular framework.
                   </p>

                   <div className="contact-btn d-flex">

                   <a href="https://www.linkedin.com/in/hridoy-ahmed-48a67a143/" target='blank'> <Button style={{margin:'5px'}} variant="outline-secondary"><i class="fab fa-linkedin"></i></Button></a>   

                   <a href="https://github.com/hridoy01-hash" target='blank'> <Button style={{margin:'5px'}} variant="outline-secondary"><i class="fab fa-github"></i></Button></a>

                   <a href="https://web.facebook.com/profile.php?id=100026579570575" target='blank'> <Button style={{margin:'5px'}} variant="outline-secondary"><i class="fab fa-facebook-f"></i></Button></a> 

                   <Button style={{margin:'5px'}} variant="outline-secondary"><i class="fab fa-twitter"></i></Button>
                   </div>
                </Fade>
                   
               </div>
           </div>
         </Container>

         
           
        </div>
    );
};

export default About;